import { cva } from '@/styled-system/css';

export const tableRootRecipe = cva({
  base: {
    borderCollapse: 'separate',
    borderSpacing: 0,
    fontVariantNumeric: 'tabular-nums',
    transform: 'translate3d(0, 0, 0)',
    isolation: 'isolate',
    zIndex: 1,
    width: '100%',
    position: 'relative',
  },
  variants: {
    appearance: {
      bare: {},
      horizontal: {},
      grid: {
        borderInlineStartWidth: 'default',
        borderInlineStartStyle: 'solid',
        borderInlineStartColor: 'border.muted-alt',
        borderBlockStartWidth: 'default',
        borderBlockStartStyle: 'solid',
        borderBlockStartColor: 'border.muted-alt',
      },
      zebra: {},
    },
    size: {
      sm: {
        textStyle: 'body-sm',
      },
      md: {
        textStyle: 'body-sm',
      },
      lg: {
        textStyle: 'body-lg',
      },
    },
  },
});
